import { message } from "antd";
import Cookies from "js-cookie";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { LoginedLayout } from "../components/layout/loginLayout";
import { UserContext } from "../context/userContext";
import { GET } from "../services";
import { AUTH_VERIFY } from "../services/path";
import { PATHNAME } from "./pathName";

export const ProtectedRoute = ({ children }: any) => {
  const { user, setUser } = useContext(UserContext);
  const navigate = useNavigate();

  const getUserInfo = async () => {
    try {
      const result = await GET(AUTH_VERIFY);
      setUser({
        department: result.Department,
        role_id: result.role_id,
        user_id: result.user_id,
        username: result.username,
        platform: result.platform,
      });

      return children;
    } catch (error: any) {
      message.warning("กรุณาเข้าสู่ระบบ");
      Cookies.remove("jwt");
      navigate(PATHNAME.LOGIN);
    }
  };

  if (user === null) {
    getUserInfo();
    return <LoginedLayout loading={true}></LoginedLayout>;
  }

  return children;
};
